import { Link } from "@fluentui/react/lib/Link";
import { TooltipHost, TooltipOverflowMode } from "@fluentui/react/lib/Tooltip";

import { getName } from "Utils/Item";
import { useLinkWithTooltipStyles } from "./UseLinkWithTooltipStyles";
import { ILinkWithTooltipProps } from "./ILinkWithTooltipProps";

export function LinkWithTooltip(props: ILinkWithTooltipProps): JSX.Element {
  const { item, onClick } = props;
  const name = getName(item);
  const styles = useLinkWithTooltipStyles();

  return (
    <TooltipHost overflowMode={TooltipOverflowMode.Self} content={name} hostClassName={styles.tooltip}>
      <Link as="a" onClick={onClick} className={styles.link}>
        {name}
      </Link>
    </TooltipHost>
  );
}
